"use strict";
require('documenteditor/documenteditor');
require('common/directives/paginationDirective');
require('common/filters');
var editCtrl = require('registration/controllers/editCtrl');
var indexCtrl = require('registration/controllers/indexCtrl');
var navCtrl = require('common/controllers/navCtrl');
var app = angular.module('registration', ['documenteditor', 'paginationDirective', 'templates', 'angular-table', 'lr.upload', 'ui.bootstrap', 'filters']);
app.controller('indexCtrl', ['$scope', '$rootScope', '$http', '$filter', '$uibModal', 'permissions', indexCtrl]);
app.controller('editCtrl', ['$scope', '$rootScope', '$http', 'id', 'values', 'schema', 'permissions', '$uibModal', editCtrl]);
app.controller('navCtrl', ['$scope', navCtrl]);
module.exports = app;
